// extracted by mini-css-extract-plugin
module.exports = {"switch":"a10a3f92e9--switch--VneCO","indicator":"a10a3f92e9--indicator--ApXPO","disabled":"a10a3f92e9--disabled--J5kyp"};